import { Field, Form, Formik } from "formik";

import { postApi, putApi } from "../../services/api/globalApi";
import {
  errorMessage,
  successMessage,
  warningMessage,
} from "../../utils/toastify-message/ToastifyMessage";

import Button from "../../components/common/button/Button";
import Input from "../../components/common/inputs/Input";
import Title from "../../components/common/title/Title";
import { useLocation, useNavigate } from "react-router";
import { useSelector } from "react-redux";
import { utilsState } from "../../sotre/redux/features/utilsSlice";
import Editor from "../../components/common/ck-editor/CkEditor";
import ImagesModal from "../../components/common/modals/imgaes-modal/ImagesModal";
import { useEffect, useRef, useState } from "react";
import { PiXSquareFill } from "react-icons/pi";
import Select from "../../components/common/inputs/Select";
import { fileUrl } from "../../services/config";
import { articleValidation } from "../../utils/validations/articleValidation";

export default function Article() {
  const location = useLocation();
  const navigate = useNavigate();
  const { utils } = useSelector(utilsState);

  const [description, setDescription] = useState(null);

  const formHandler = async (values, { resetForm }) => {
    const body = { ...values, description, seoKeywords, image };
    try {
      if (!location?.state) {
        const response = await postApi({
          path: "admin/articles",
          body: JSON.stringify(body),
        });
        console.log(response);
        successMessage("مقاله با موفقیت اضافه شد");
        resetForm();
      } else {
        const response = await putApi({
          path: `admin/articles/${location?.state.id}`,
          body: JSON.stringify(body),
        });
        successMessage("اطلاعات مقاله با موفقیت آپدیت شد.");
      }
      navigate("/article-list");
    } catch (error) {
      console.error(error);
      errorMessage(error?.response?.data?.errors[0].message);
    }
  };

  const imagesModal = useRef();

  const copyImagesUrlModal = useRef();

  const [image, setImage] = useState("");

  const selectedImages = (item) => {
    console.log(item);
    if (item) {
      setImage(item.name);
      successMessage("عکس اضافه شد.");
    }
  };

  const [newKeyword, setNewKeywords] = useState("");
  const [seoKeywords, setKeywords] = useState([]);

  const addSeoKeyWords = () => {
    if (newKeyword.length) {
      setKeywords((prev) => [...prev, newKeyword]);
      setNewKeywords("");
    } else {
      warningMessage("لطفا مقدار تگ را وارد کنید.");
    }
  };

  const deleteSeoKeywords = (index) => {
    let newKeyword = [...seoKeywords];
    newKeyword.splice(index, 1);
    setKeywords(newKeyword);
  };

  useEffect(() => {
    if (location?.state?.seoKeywords) {
      setKeywords(location?.state?.seoKeywords);
    }
    if (location?.state?.image) {
      setImage(location?.state?.image);
    }
  }, [location.state]);

  return (
    <div className="bg-white dark:bg-gray-900 rounded-3xl p-6">
      <Title title={!location.state ? "افزودن مقاله" : "ویرایش مقاله"} />
      <Formik
        enableReinitialize
        initialValues={
          location.state
            ? {
              name: location?.state.name || "",
              urlKey: location?.state.urlKey || "",
              shortDescription: location?.state.shortDescription || "",
              seoDescription: location?.state.seoDescription || "",
              status: location?.state.status || "",
              seoKeywords: location?.state.seoKeywords || "",
              type: location?.state.type || "",
            }
            : {
              name: "",
              shortDescription: "",
              seoDescription: "",
              status: utils?.ARTICLE_STATUS_VALUES[0]?.value || "active",
              type: utils?.ARTICLE_TYPES_VALUES[0]?.value || "learn",
            }
        }
        validationSchema={articleValidation}
        onSubmit={formHandler}
      >
        {() => (
          <Form>
            <div className="mt-6">
              <div className="grid gap-6 mb-4 md:grid-cols-2">
                <Input
                  name={"name"}
                  placeholder={"نام"}
                  label="نام"
                  type="text"
                />
                <Input
                  name={"urlKey"}
                  placeholder={"کلید url"}
                  label="کلید url"
                  type="text"
                />
                <Input
                  name={"shortDescription"}
                  placeholder={"توضیحات کوتاه"}
                  label="توضیحات کوتاه"
                  type="text"
                />
                <Input
                  name={"seoDescription"}
                  placeholder={"توضیحات سئو"}
                  label={"توضیحات سئو"}
                  type="text"
                />
                <Field
                  as="select"
                  name="status"
                  label="وضعیت"
                  component={Select}
                >
                  {utils
                    ? utils?.ARTICLE_STATUS_VALUES?.map((item) => {
                      return <option value={item.value}>{item.name}</option>;
                    })
                    : null}
                </Field>
                <Field
                  as="select"
                  name="type"
                  label="نوع مقاله"
                  component={Select}
                >
                  {utils
                    ? utils?.ARTICLE_TYPES_VALUES?.map((item) => {
                      return <option value={item.value}>{item.name}</option>;
                    })
                    : null}
                </Field>
            
              </div>
              <div className="grid gap-6 mb-4 md:grid-cols-2">
                  <div>
                    <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                      کلمات کلیدی سئو
                    </label>
                    <input
                      value={newKeyword}
                      onChange={(e) => setNewKeywords(e.target.value)}
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                    />
                  </div>
                  <div className="flex flex-col mt-8 gap-y-2">
                    <div className="">
                      <Button
                        onClick={addSeoKeyWords}
                        type="button"
                        text={"افزودن"}
                        color={"primary"}
                      />
                    </div>
                  </div>
                </div>
                <div className="flex items-center flex-wrap gap-3">
                  {seoKeywords?.map((item, index) => {
                    return (
                      <button
                        type="button"
                        class="relative text-blue-700 hover:text-white border border-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center me-2 mb-2 dark:border-blue-500 dark:text-blue-500 dark:hover:text-white dark:hover:bg-blue-500 dark:focus:ring-blue-800"
                      >
                        <PiXSquareFill
                          onClick={() => deleteSeoKeywords(index)}
                          size={26}
                          className={"absolute -top-2 -right-2 text-red-500"}
                        />
                        {item}
                      </button>
                    );
                  })}
                </div>
                <div className="">
                  <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                    عکس
                  </label>
                  <div className="flex items-center justify-between">
                    <div className="flex gap-2">
                      {image ? (
                        <img
                          src={`${fileUrl}files/thumb_${image}`}
                          className="w-16 h-16 rounded-lg"
                          alt=""
                        />
                      ) : (
                        <p className="text-sm dark:text-white">هنوز هیچ عکسی اننتخاب نشده</p>
                      )}
                      {/* <p className="max-w-12 overflow-hidden">{image || ""}</p> */}
                    </div>
                    <div className="flex gap-2">
                      {image && (
                        <Button
                          type="button"
                          onClick={() => setImage("")}
                          text={"حذف"}
                          color={"danger"}
                        />
                      )}

                      <Button
                        type="button"
                        onClick={() => imagesModal.current.showModal()}
                        text={image ? "ویرایش" : "انتخاب"}
                        color={"success"}
                      />
                    </div>
                  </div>
                </div>

              <Button
                type="button"
                onClick={() => copyImagesUrlModal.current.showModal()}
                text={"انتخاب عکس"}
                color={"primary"}
                className="mb-3"
              />
              <div className="flex flex-col gap-y-2">
                <Editor filed={"description"} onChange={setDescription} />
                <div className="flex items-center gap-2 mt-6">
                  <Button
                    text={location?.state ? "ویرایش" : "افزون"}
                    color={"success"}
                  />
                </div>
              </div>
            </div>
          </Form>
        )}
      </Formik>
      <ImagesModal selectedImages={selectedImages} ref={imagesModal} />
      <ImagesModal selectImg={false} ref={copyImagesUrlModal} />
    </div>
  );
}
